import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MoveBackToDraft = forwardRef<SVGSVGElement, IconProps>(({ size = 32 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 35 37"
      fill="none"
      ref={forwardedRef}
    >
      <g opacity="0.7" filter="url(#filter0_d_2678_16076)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4711 10.7482C15.4463 11.0349 15.4237 11.2957 15.39 11.5398C15.4499 11.3589 15.5114 11.171 15.5746 10.9772C16.1397 9.24742 16.8544 7.05963 18.0248 5.42518C19.5589 4.02287 21.5448 3.16434 23.6699 3.03688L27.2267 2.82353C21.2271 6.21643 16.2613 15.231 12.2233 22.5614C11.9234 23.1058 11.6286 23.641 11.3388 24.1639L11.0453 19.2699C10.9324 17.3876 11.4018 15.5162 12.3898 13.9101L15.8222 8.3299C15.5934 9.33397 15.5266 10.106 15.4711 10.7482Z"
          fill="url(#paint0_linear_2678_16076)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6663 23.9437L12.6983 24.4668C14.9258 17.1649 20.7815 6.46852 27.2267 2.82361L27.9853 6.86862C28.0794 7.37028 28.1097 7.87763 28.0782 8.37929C27.6228 10.6316 24.3887 12.06 21.9947 13.1174C21.5867 13.2976 21.2031 13.467 20.8618 13.6279C21.2028 13.5677 21.6178 13.5107 22.0819 13.4469C23.2923 13.2805 24.8366 13.0682 26.2743 12.6335C26.2366 12.7063 26.1985 12.7782 26.1598 12.8492L25.4704 13.9582C23.604 16.5988 20.9959 17.8 18.8637 18.782C18.6274 18.8908 18.397 18.9969 18.1741 19.102C19.4186 18.8822 21.4979 18.0925 23.4423 17.2201L21.8696 19.7496C20.4918 21.9657 18.2361 23.4907 15.6663 23.9437ZM26.2886 12.6292L26.2932 12.6347L26.2985 12.6262C26.2952 12.6272 26.2919 12.6282 26.2886 12.6292Z"
          fill="url(#paint1_linear_2678_16076)"
        />
        <path
          d="M10.5 30.5099L8.13143 30.5099C14.4437 17.7722 20.9335 6.03512 27.2267 2.82392C24.5132 4.20855 15.4412 14.7366 10.5 30.5099Z"
          fill="url(#paint2_linear_2678_16076)"
        />
      </g>
      <g filter="url(#filter1_bd_2678_16076)">
        <path
          d="M9.15 7.24464L2.34993 16.2401L9.15 24.5506L9.15 20.0316C19.7545 19.1552 27.6313 21.8124 25.2001 25.1007C28.4164 23.7918 29.8349 19.038 27.2467 16.24C24.6586 13.442 18.4715 11.4306 9.15 12.1387L9.15 7.24464Z"
          fill="url(#paint3_linear_2678_16076)"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2678_16076"
          x="0.188793"
          y="0.0804751"
          width="35.6224"
          height="40.3106"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.59322" />
          <feGaussianBlur stdDeviation="3.14407" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2678_16076" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2678_16076" result="shape" />
        </filter>
        <filter
          id="filter1_bd_2678_16076"
          x="-1.65009"
          y="3.24414"
          width="34.2373"
          height="25.8574"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2678_16076" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_2678_16076" result="effect2_dropShadow_2678_16076" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2678_16076" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2678_16076"
          x1="18.4825"
          y1="12.4397"
          x2="15.3832"
          y2="10.7158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B84FF" />
          <stop offset="1" stopColor="#1E85FF" stopOpacity="0.42" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2678_16076"
          x1="28.2129"
          y1="9.85911"
          x2="12.5059"
          y2="22.5901"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00879028" stopColor="#006EEE" stopOpacity="0.55" />
          <stop offset="1" stopColor="#1B84FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2678_16076"
          x1="13.0429"
          y1="18.2383"
          x2="17.6321"
          y2="20.8476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B8BF9" />
          <stop offset="1" stopColor="#003B77" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2678_16076"
          x1="19.1346"
          y1="19.944"
          x2="19.885"
          y2="10.189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#061825" />
          <stop offset="0.864744" stopColor="#06304E" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default MoveBackToDraft
